import React, { useEffect, useRef } from 'react';

export type UseRunOnceProps = {
  fn: () => unknown;
  sessionKey?: string;
};

const useRunOnce: React.FC<UseRunOnceProps> = ({ fn, sessionKey }) => {
  const triggered = useRef<boolean>(false);

  useEffect(() => {
    const hasBeenTriggered = sessionKey ? sessionStorage.getItem(sessionKey) : triggered.current;

    if (!hasBeenTriggered) {
      fn();
      triggered.current = true;

      if (sessionKey) {
        sessionStorage.setItem(sessionKey, 'true');
      }
    }
  }, [fn, sessionKey]);

  return null;
};

export default useRunOnce;
